import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { PermissaoService } from '../../services/permissao/permissao.service';

@Component({
  selector: 'app-sem-permissao',
  templateUrl: './sem-permissao.component.html',
  styleUrl: './sem-permissao.component.scss',
})
export class SemPermissaoComponent implements OnDestroy {
  texts = { titulo: '', mensagem: '', voltar: '' };

  private langChangeSub!: Subscription;

  constructor(
    private router: Router,
    private permissaoService: PermissaoService,
    private translate: TranslateService,
  ) {
    this.carregarTextos();
    this.langChangeSub = this.translate.onLangChange.subscribe(() => this.carregarTextos());
  }

  ngOnDestroy(): void {
    if (this.langChangeSub) {
      this.langChangeSub.unsubscribe();
    }
  }

  private carregarTextos(): void {
    this.texts = {
      titulo: this.translate.instant('sem_permissao.titulo'),
      mensagem: this.translate.instant('sem_permissao.mensagem'),
      voltar: this.translate.instant('sem_permissao.voltar'),
    };
  }

  voltar(): void {
    const rota = this.permissaoService.obterPrimeiraRotaAcessivel();
    this.router.navigateByUrl(rota);
  }
}
